import React from "react";
import { Button } from "@/components/ui/button";
import { Plus, LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  actionLabel: string;
  onAction: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  actionLabel,
  onAction,
}) => (
  <div className="flex flex-col h-[calc(100vh-8rem)] gap-y-4 items-center justify-center text-center">
    <Icon className="w-10 h-10 text-secondary-n-50" strokeWidth={1} />
    <p className="text-lg text-secondary-n-400">{title}</p>
    <Button
      size="sm"
      variant="primary"
      onClick={onAction}
      className="text-xs rounded-md h-7 pl-1.5 pr-2"
    >
      <Plus className="w-4 h-4 mr-1" />
      {actionLabel}
    </Button>
  </div>
);
